var host = window.location.hostname
let settings = {
  tokenPath: 'api/func-auth',
  storageUrl: 'https://www.hme.com/qsr/cloud/link',
  idleTime: 900000, // in milliseconds
  waitTime: 20000, // in milliseconds
  autoRefreshTime: 300000,
  coldFusionPages: [],
  upgradableDeviceVersionTypes: ['3.6', '3.7', '3.8', '3.9', '3.10', '3.11'],
  // Admin non perforamable actions - This will not allow the admin to perform following actions.
  excludePermissionsForAdmin: ['AddRole', 'AddUser', 'RemoveRole', 'RemoveUser', 'EditStoreBasic'],
  infiniteScrollPageSize: 500,
  useFacade: true
}

if (host.indexOf('-dev-') > -1 || host.indexOf('engdev.hmedtcloud') > -1) { // DEV Environment
  settings.adminColdFusionUrl = 'http://devcloudadmin.hme.com/'
  settings.coldFusionUrl = 'https://engdev.hmedtcloud.com/'
  settings.apiBaseUrl = 'https://hme-dev-public-cloud-func.azurewebsites.net/'
  settings.authBaseUrl = 'https://hme-dev-public-cloud-func.azurewebsites.net/'
  settings.actionUrl = 'https://hme-dev-dtcloud-facade.azurewebsites.net/'
  settings.facadeToken = 'aG1lLWZhY2FkZTpub3VzOzEyMw=='
  settings.trainingPortalBaseUrl = 'https://uathme.hme.com/training/?token='
  settings.leaderboardsBaseUrl = 'https://hme-dev-leaderboard.azurewebsites.net/?all&storeUID='
} else if (host.indexOf('-uat-') > -1 || host.indexOf('uat.hmedtcloud') > -1) { // UAT environment
  settings.adminColdFusionUrl = 'https://uatadmin.hme.com/hmecloud/'
  settings.coldFusionUrl = 'https://uat.hmedtcloud.com/'
  settings.apiBaseUrl = 'https://hme-uat-dtcloud-service.azurewebsites.net/'
  settings.authBaseUrl = 'https://hme-uat-dtcloud-service.azurewebsites.net/'
  settings.actionUrl = 'https://hme-uat-dtcloud-facade.azurewebsites.net/'
  settings.facadeToken = 'aG1lLWZhY2FkZTpuN1k/ckB2Nzl9ITk='
  settings.trainingPortalBaseUrl = 'https://uathme.hme.com/training/?token='
  settings.leaderboardsBaseUrl = 'https://hme-uat2-leaderboard.azurewebsites.net/?all&storeUID='
} else if (host.indexOf('-live-') > -1 || host.indexOf('hmedtcloud') > -1) { // LIVE Environment
  settings.adminColdFusionUrl = 'https://admin.hme.com/hmecloud/'
  settings.coldFusionUrl = 'https://hmedtcloud.com/'
  settings.apiBaseUrl = 'https://hme-live-cloud-service.azurewebsites.net/'
  settings.authBaseUrl = 'https://hme-live-cloud-service.azurewebsites.net/'
  settings.actionUrl = 'https://hme-live-dtcloud-facade.azurewebsites.net/'
  settings.facadeToken = 'aG1lLWZhY2FkZTpub3VzOzEyMw=='
  settings.trainingPortalBaseUrl = 'https://www.hme.com/training/?token='
  settings.leaderboardsBaseUrl = 'https://hme-live2-leaderboard.azurewebsites.net/?all&storeUID='
} else { // LOCALHOST
  settings.adminColdFusionUrl = 'http://devcloudadmin.hme.com/'
  settings.coldFusionUrl = 'https://engdev.hmedtcloud.com/'
  settings.apiBaseUrl = 'https://hme-dev-public-cloud-func.azurewebsites.net/'
  settings.authBaseUrl = 'https://hme-dev-public-cloud-func.azurewebsites.net/'
  settings.actionUrl = 'https://hme-dev-dtcloud-facade.azurewebsites.net/'
  settings.facadeToken = 'aG1lLWZhY2FkZTpub3VzOzEyMw=='
  settings.trainingPortalBaseUrl = 'https://uathme.hme.com/training/?token='
  settings.leaderboardsBaseUrl = 'https://hme-dev-leaderboard.azurewebsites.net/?all&storeUID='

}

export const Config = settings



// WEBPACK FOOTER //
// ./src/Config.js